import {
  isDevBuild,
  isProdBuild,
  isStagingBuild,
  useStvV2UserData,
} from '@amagimedia/commons';
import LogRocket from 'logrocket';
import type { FC } from 'react';
import { version as bifrostVersion } from '../../../../../package.json';

const logRocketAN3Key = 'dp1ew8/amaginow3' as const;

declare global {
  var pendo: any;
}

export const LoadExternalServices: FC = () => {
  const { user_email_id, user_name, amgId, user_role } = useStvV2UserData();
  if (!user_email_id || !user_name) {
    return null;
  }

  const shouldUseLogrocket = !isDevBuild && process.env.LOGROCKET_KEY;

  if (shouldUseLogrocket) {
    LogRocket.init(logRocketAN3Key);
  }

  if (isProdBuild || isStagingBuild) {
    pendo.initialize({
      visitor: {
        id: `${process.env.ENV_TYPE}-${user_email_id.toString()}`, // Required if user is logged in, default creates anonymous ID
        email: user_email_id,
        role: user_role,
        application: 'AN3.0',
        // full_name:    // Recommended if using Pendo Feedback

        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
      },

      account: {
        id: amgId, // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
        domain: amgId,
        // name:         // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
        // planLevel:    // Optional
        // planPrice:    // Optional
        // creationDate: // Optional

        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      },
    });
  }

  if (!shouldUseLogrocket) {
    return null;
  }

  LogRocket.identify(amgId, {
    name: user_name,
    email: user_email_id,
    stvVersion: bifrostVersion,
    subscriptionType: 'pro',
  });

  return null;
};
